import { useBalanceStore } from '@/entities/balance';
import { useFeatureFlags, useSettings } from '@/entities/user/currentUser';

import { IS_WHITE_LABEL } from '@/shared/environments';

import { getOnscreenOffer } from '../lib/getOnscreenOffer';

const DEFAULT_MINUTES_COST_MULTIPLIER = 3;

// Who can use on-screen text translation and what a plan without it is offered.
// localization_app reports the feature as not visible where the service is off, so nothing shows there; it checks the
// plan again before charging. Phones get it too: their project page (MobileContent) has a Visual tab of its own.
export const useOnscreenAccess = () => {
  const { featureEnabled, featureVisible } = useFeatureFlags('onscreen');
  const { scope_settings } = useSettings();
  const hasEnterprisePlan = useBalanceStore((state) => state.hasEnterprisePlan);
  const planCategory = useBalanceStore((state) => state.planCategory);

  const multiplier = Number(scope_settings.available_features.onscreen?.metadata?.minutes_cost_multiplier);
  // A white-label build has no plans to sell, so a plan without the feature does not see it at all.
  const isLocked = !featureEnabled && featureVisible && !IS_WHITE_LABEL;

  return {
    isEnabled: featureEnabled,
    isLocked,
    isVisible: featureEnabled || isLocked,
    minutesCostMultiplier: multiplier > 0 ? multiplier : DEFAULT_MINUTES_COST_MULTIPLIER,
    offer: getOnscreenOffer({ hasEnterprisePlan, planCategory }),
  };
};
